import React from 'react';
import { NotFound } from '../../components/not-found';
import { PageMessage } from '../page-message';

export const PageNotFound: React.FC = () => <PageMessage message={<NotFound />} />;
